import {routeTo} from '@/utils/router'

export const getHowItWorksContent = () => ({
  metaTitle: 'marketing-pages-common.how-it-works-meta-title',
  metaDescription: 'marketing-pages-common.how-it-works-meta-desc',
  header: {
    buttonLinkText: 'button-start-with-registration',
    buttonLinkHref: routeTo.verification.form(),
  },
  process: {
    title: 'marketing-pages-common.how-it-works-title',
    description: 'marketing-pages-common.how-it-works-description',
    steps: [
      {
        id: 'verification',
        title: 'marketing-pages-common.how-it-works-step-title-0',
        duration: 'marketing-pages-common.how-it-works-step-duration-0',
        description: 'marketing-pages-common.how-it-works-step-desc-0',
        iconSrc: '/images/icons/verification-step.svg',
        iconAlt: 'Trademark verification',
        imageSrc: '/images/how-it-works/verification-result.png',
        imageAlt: 'Verification result',
        longDescription: ['marketing-pages-common.how-it-works-step-long-desc-0'],
        viewDemoVerificationResult: 'marketing-pages-common.how-it-works-view-demo-result',
        learnMoreLinkText: 'learn-more-text',
        learnMoreLinkHref: routeTo.trademarkSearch(),
        faqs: {
          title: 'marketing-pages-common.how-it-works-step-faq-title-0',
          list: [
            {
              question: 'marketing-pages-common.how-it-works-step-faq-question-0-0',
              answer: 'marketing-pages-common.how-it-works-step-faq-answer-0-0',
            },
            {
              question: 'marketing-pages-common.how-it-works-step-faq-question-0-1',
              answer: 'marketing-pages-common.how-it-works-step-faq-answer-0-1',
            },
          ],
        },
      },
      {
        id: 'filing',
        title: 'marketing-pages-common.how-it-works-step-title-1',
        duration: 'marketing-pages-common.how-it-works-step-duration-1',
        description: 'marketing-pages-common.how-it-works-step-desc-1',
        iconSrc: '/images/icons/drafting-step.svg',
        iconAlt: 'Filling the registration',
        imageSrc: '/images/how-it-works/cp-dashboard.png',
        imageAlt: 'Dashboard in customer portal',
        longDescription: ['marketing-pages-common.how-it-works-step-long-desc-1'],
        faqs: {
          title: 'marketing-pages-common.how-it-works-step-faq-title-1',
          list: [
            {
              question: 'marketing-pages-common.how-it-works-step-faq-question-1-0',
              answer: 'marketing-pages-common.how-it-works-step-faq-answer-1-0',
            },
            {
              question: 'marketing-pages-common.how-it-works-step-faq-question-1-1',
              answer: 'marketing-pages-common.how-it-works-step-faq-answer-1-1',
            },
          ],
        },
      },
      {
        id: 'assessment',
        title: 'marketing-pages-common.how-it-works-step-title-2',
        duration: 'marketing-pages-common.how-it-works-step-duration-2',
        description: 'marketing-pages-common.how-it-works-step-desc-2',
        iconSrc: '/images/icons/assessment-step.svg',
        iconAlt: 'Assessment by the trademark office',
        imageSrc: '/images/how-it-works/application-notifications.png',
        imageAlt: 'Notifications about application in customer portal',
        longDescription: ['marketing-pages-common.how-it-works-step-long-desc-2'],
        linkHref: routeTo.blog.article(
          'how-long-does-it-take-to-register-a-trademark-march-22-update',
        ),
        faqs: {
          title: 'marketing-pages-common.how-it-works-step-faq-title-2',
          list: [
            {
              question: 'marketing-pages-common.how-it-works-step-faq-question-2-0',
              answer: 'marketing-pages-common.how-it-works-step-faq-answer-2-0',
            },
            {
              question: 'marketing-pages-common.how-it-works-step-faq-question-2-1',
              answer: 'marketing-pages-common.how-it-works-step-faq-answer-2-1',
            },
          ],
        },
      },
      {
        id: 'tm-registered',
        title: 'marketing-pages-common.how-it-works-step-title-3',
        duration: 'marketing-pages-common.how-it-works-step-duration-3',
        description: 'marketing-pages-common.how-it-works-step-desc-3',
        iconSrc: '/images/icons/validity.svg',
        iconAlt: 'Trademark certificate',
        imageSrc: '/images/how-it-works/registration-timeline.png',
        imageAlt: 'Progress tracking for registration',
        longDescription: ['marketing-pages-common.how-it-works-step-long-desc-3'],
      },
    ],
  },
  getStarted: {
    title: 'marketing-pages-common.how-it-works-get-started-title',
    description: 'marketing-pages-common.how-it-works-get-started-desc',
    buttonText: 'button-start-with-lawyer-check',
    buttonLink: routeTo.verification.form(),
    contactNote: 'marketing-pages-common.how-it-works-get-started-contact',
    imageSrc: '/images/person-carrying-ice-cream.svg',
    imageAlt: 'A person carrying an ice cream',
  },
})
